export const translations = {
  navBrand: {
    en: 'Fast Flag Fast',
    fr: 'Fast Flag Fast',
    es: 'Fast Flag Fast'
  },
  dailyFlag: {
    en: 'Daily Flag',
    fr: 'Drapeau du jour',
    es: 'Bandera del día'
  },
  classicMode: {
    en: 'Classic Quiz',
    fr: 'Quiz classique',
    es: 'Quiz clásico'
  },
  allFlags: {
    en: 'All Flags',
    fr: 'Tous les pays',
    es: 'Todos los países'
  },
  language: {
    en: 'Language',
    fr: 'Langue',
    es: 'Idioma'
  },
  placeholder: {
    en: 'Enter country name',
    fr: 'Entrez le nom du pays',
    es: 'Escribe el nombre del país'
  },
  skip: {
    en: 'Skip',
    fr: 'Passer',
    es: 'Saltar'
  },
  previousFlagTitle: {
    en: "Yesterday's flag",
    fr: 'Drapeau d\'hier',
    es: 'Bandera de ayer'
  },
  recentFlagsTitle: {
    en: 'Last 5 flags',
    fr: '5 derniers drapeaux',
    es: 'Últimas 5 banderas'
  },
  won: {
    en: 'Won',
    fr: 'Gagné',
    es: 'Ganado'
  },
  lost: {
    en: 'Lost',
    fr: 'Perdu',
    es: 'Perdido'
  },
  loading: {
    en: 'Loading...',
    fr: 'Chargement...',
    es: 'Cargando...'
  },
  errorLoading: {
    en: 'Error loading flag',
    fr: 'Erreur de chargement',
    es: 'Erreur de chargement'
  },
  dailyLandingTitle: {
    en: 'Guess the daily hidden flag in 5 tries',
    fr: 'Devinez le drapeau caché du jour en 5 essais',
    es: 'Adivina la bandera oculta del día en 5 intentos'
  },
  dailyLandingSubtitle: {
    en: 'One shared flag for everyone, a new challenge every day at 00:00 Paris time.',
    fr: 'Un drapeau commun à tous, un nouveau défi chaque jour à 00h00 heure de Paris.',
    es: 'Una bandera compartida para todos, un nuevo reto cada día a las 00:00 hora de París.'
  },
  playDaily: {
    en: 'Play Daily Flag',
    fr: 'Jouer au Drapeau du jour',
    es: 'Jugar Bandera del día'
  },
  playClassic: {
    en: 'Play Classic Quiz',
    fr: 'Jouer au Quiz classique',
    es: 'Jugar Quiz clásico'
  },
  dailyCountdownLabel: {
    en: 'Next flag in',
    fr: 'Prochain drapeau dans',
    es: 'Próxima bandera en'
  },
  dailyAttemptsLeft: {
    en: '{count} tries left',
    fr: '{count} essais restants',
    es: '{count} intentos restantes'
  },
  dailyWinMessage: {
    en: 'You found it!',
    fr: 'Vous l’avez trouvé !',
    es: '¡Lo encontraste!'
  },
  dailyLoseMessage: {
    en: 'Today’s flag is revealed',
    fr: 'Le drapeau du jour est révélé',
    es: 'La bandera de hoy está revelada'
  },
  dailySolvedIn: {
    en: 'Solved in {attempts} tries',
    fr: 'Trouvé en {attempts} essais',
    es: 'Resuelto en {attempts} intentos'
  },
  dailySolvedBadge: {
    en: 'Solved in {attempts} tries',
    fr: 'Résolu en {attempts} essais',
    es: 'Resuelto en {attempts} intentos'
  },
  dailySolvedSubtitle: {
    en: '{count} people also found this flag today',
    fr: '{count} personnes ont aussi trouvé ce drapeau aujourd\'hui',
    es: '{count} personas también encontraron esta bandera hoy'
  },
  dailyCorrectAnswer: {
    en: 'The answer was {name}.',
    fr: 'La réponse était {name}.',
    es: 'La respuesta era {name}.'
  },
  dailyComeBackTomorrow: {
    en: 'Come back tomorrow',
    fr: 'Revenez demain',
    es: 'Vuelve mañana'
  },
  dailyShare: {
    en: 'Share',
    fr: 'Partager',
    es: 'Compartir'
  },
  dailyCopied: {
    en: 'Copied to clipboard',
    fr: 'Copié dans le presse-papiers',
    es: 'Copiado al portapapeles'
  },
  classicSuccessRate: {
    en: 'Success rate: {rate}',
    fr: 'Taux de réussite : {rate}',
    es: 'Tasa de éxito: {rate}'
  },
  classicCurrentStreak: {
    en: 'Current streak: {streak}',
    fr: 'Série en cours : {streak}',
    es: 'Racha actual: {streak}'
  },
  classicStreakLabel: {
    en: 'Streak',
    fr: 'Série',
    es: 'Racha'
  },
  classicSuccessLabel: {
    en: 'Success',
    fr: 'Succès',
    es: 'Éxito'
  },
  dailyBoardTitle: {
    en: 'Guesses',
    fr: 'Tentatives',
    es: 'Intentos'
  },
  dailyGameReady: {
    en: 'The hidden flag reveals itself with each attempt.',
    fr: 'Le drapeau caché se révèle à chaque tentative.',
    es: 'La bandera oculta se revela con cada intento.'
  },
  dailyGuessButton: {
    en: 'Guess',
    fr: 'Deviner',
    es: 'Adivinar'
  },
  dailyModeDescription: {
    en: 'A new shared challenge every day at 00:00 Paris time.',
    fr: 'Un nouveau défi partagé chaque jour à 00h00 heure de Paris.',
    es: 'Un nuevo desafío compartido cada día a las 00:00 hora de París.'
  },
  dailyClassicDescription: {
    en: 'Keep using the classic random quiz mode with regions and infinite play.',
    fr: 'Continuez avec le mode quiz classique aléatoire, régions et jeu infini.',
    es: 'Sigue con el modo clásico aleatorio, regiones y juego infinito.'
  },
  dailyShareResult: {
    en: 'Daily Flag #{day}\n{pattern}',
    fr: 'Drapeau du jour #{day}\n{pattern}',
    es: 'Bandera del día #{day}\n{pattern}'
  },
  dailyFoundCount: {
    en: '{count} people found this flag today',
    fr: '{count} personnes ont trouvé ce drapeau aujourd\'hui',
    es: '{count} personas encontraron esta bandera hoy'
  },
  dailyFlagCountdownTitle: {
    en: 'Daily Flag',
    fr: 'Drapeau du jour',
    es: 'Bandera del día'
  }
};

export const getText = (key, language, vars = {}) => {
  const value = translations[key]?.[language] || key;
  return Object.entries(vars).reduce(
    (current, [name, replacement]) => current.replace(`{${name}}`, replacement),
    value
  );
};
